import React from 'react';
import styles from './PunchupTableLayout.module.css';

interface PunchupTableLayoutProps {
	className?: string;
	children?: React.ReactNode;
}

/**
 * Sized-to-content wrapper for a `PunchupTableContainer` and any siblings
 * (typically `PunchupLoadMore`) that should share the same horizontal extent
 * as the table.
 *
 * Width: `max-content` capped at `100%`. When the table fits within the
 * parent width, the layout (and any centered sibling) sits at the table's
 * natural content width. When the table exceeds the parent width, the layout
 * caps at the parent and the table's own scroll wrapper handles the overflow.
 *
 * See `PunchupTable/CLAUDE.md` → "Layout regimes" for the full sizing model.
 */
export function PunchupTableLayout({ className, children }: PunchupTableLayoutProps) {
	return <div className={[styles.layout, className].filter(Boolean).join(' ')}>{children}</div>;
}
